import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProofOfBankDocumentTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromProofOfBankDocumentTypesReducer.proofOfBankDocumentTypesFeatureKey]
);

export const getStaticDataProofOfBankDocumentTypesFailure = createSelector(
  getStaticDataProofOfBankDocumentTypesState,
  staticDataCountriesReducer.fromProofOfBankDocumentTypesReducer.getProofOfBankDocumentTypesError
);

export const getStaticDataProofOfBankDocumentTypesResponse = createSelector(
  getStaticDataProofOfBankDocumentTypesState,
  staticDataCountriesReducer.fromProofOfBankDocumentTypesReducer.getProofOfBankDocumentTypes
);
